import * as React from "react";
function SvgVkontaktePage(
  props: React.SVGProps<SVGSVGElement>,
  svgRef?: React.Ref<SVGSVGElement>
) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 32 32"
      ref={svgRef}
      {...props}
    >
      <path d="M26.78 20.41A21 21 0 0029 16.62c.07-.34-.08-.52-.43-.52h-1.75a.64.64 0 00-.67.43A15.92 15.92 0 0124 19.82c-.37.41-.56.54-.76.54s-.24-.14-.24-.51v-3.26c0-.46-.05-.59-.43-.59h-2.78a.31.31 0 00-.35.3c0 .43.66.53.66 1.69v2.4c0 .48 0 .67-.25.67-.6 0-2-2.08-2.84-4.44-.16-.48-.34-.62-.79-.62h-1.77a.42.42 0 00-.44.43c0 .47.55 2.64 2.71 5.55a6.66 6.66 0 005.07 3c1 0 1.3-.17 1.3-.62v-1.5c0-.38.15-.54.36-.54s.67.08 1.66 1.06C26.3 24.53 26.38 25 27 25h2c.2 0 .39-.09.39-.43a4.76 4.76 0 00-1.46-2.17c-.36-.48-1-1-1.14-1.25s-.2-.44-.01-.74z" />
      <path d="M15 24V7.54a.51.51 0 10-1 0v.86a27.36 27.36 0 00-3.54-.4h-.13C8.79 8.06 7 9 5 9.06a4.09 4.09 0 01-2.34-.51v8.18a10.43 10.43 0 003 .51c1.93 0 2.83-1 4.68-1a24.58 24.58 0 013.59.33V24h-1.54v1h4.11v-1zm-4.63-8.8a7.22 7.22 0 00-2.65.57 5.49 5.49 0 01-2 .46 8.79 8.79 0 01-2-.26V10a7.57 7.57 0 001.28.09 12.29 12.29 0 003.29-.6 8.92 8.92 0 012-.43h.11a27.48 27.48 0 013.47.36v6.08a25.17 25.17 0 00-3.54-.33z" />
    </svg>
  );
}
const ForwardRef = React.forwardRef(SvgVkontaktePage);
const MemoForwardRef = React.memo(ForwardRef);
export default MemoForwardRef;
